import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const BlogFooter = ({ author, one, two, three }) => (
  <div className="container my-0 mx-auto">
    <div className="text-left text-lg leading-relaxed">
      {author === "Isaac P. Ale" && (
        <div className="my-0 mx-auto max-w-4xl text-center pt-0 px-4 pb-6">
          <span className="text-xl author font-bold">Isaac P. Ale</span> <span className="bio">is a founding partner of Film & Froth and a member of the Cascadia Film and Television Critics Association, and the International Film Society Critics</span>
        </div>
      )}
      {author === "Hopster" && (
        <div className="my-0 mx-auto max-w-4xl text-center pt-0 px-4 pb-6">
          <span className="text-xl author font-bold">Hopster</span> is a founding partner of Film & Froth and lives in Chicago where he is an active member of the Music Box Theatre community
        </div>
      )}
    </div>
    {(one || two || three) && (
      <div className="container my-0 mx-auto flex">
        <h3 className="mx-auto w-75 md:w-100 border-black border-b-2">
          You May Also Like:
        </h3>
      </div>
    )}
    {(one || two || three) && (
      <div className="container my-4 mx-auto block md:flex">
        {one && (
          <a
            href={one.node.path}
            className="align-middle no-underline w-3/4 block mx-auto md:mx-4 text-center transition ease-in-out duration-250 transform hover:translate-y-1 hover:scale-105"
          >
            <GatsbyImage
              alt={one.node.title}
              className="overflow-hidden transition-all duration-250 transition ease-in-out transform bg-center bg-cover group-hover:scale-110"
              image={getImage(one.node.previewImage || one.node.seoPic)}
              loading="lazy"
            />
            <h4 className="text-black no-underline mx-2 w-auto">
              {one.node.title}
            </h4>
          </a>
        )}
        {two && (
          <a
            href={two.node.path}
            className="align-middle no-underline w-3/4 block mx-auto md:mx-4 text-center transition ease-in-out duration-250 transform hover:translate-y-1 hover:scale-105"
          >
            <GatsbyImage
              alt={two.node.title}
              className="overflow-hidden transition-all duration-250 transition ease-in-out transform bg-center bg-cover group-hover:scale-110"
              image={getImage(two.node.previewImage || two.node.seoPic)}
              loading="lazy"
            />
            <h4 className="text-black no-underline mx-2 w-auto">
              {two.node.title}
            </h4>
          </a>
        )}
        {three && (
          <a
            href={three.node.path}
            className="align-middle no-underline w-3/4 block mx-auto md:mx-4 text-center transition ease-in-out duration-500 transform hover:translate-y-1 hover:scale-105"
          >
            <GatsbyImage
              alt={two.node.title}
              className="overflow-hidden transition-all duration-250 transition ease-in-out transform bg-center bg-cover group-hover:scale-110"
              image={getImage(three.node.previewImage || three.node.seoPic)}
              loading="lazy"
            />
            <h4 className="text-black no-underline mx-2 w-auto">
              {three.node.title}
            </h4>
          </a>
        )}
      </div>
    )}
  </div>
)

export default BlogFooter
